(function initOfferType() {
  window.getSubmissionOfferForCurrentPage = function () {
    function getSubmissionOfferFromQueryString() {
      const r = new URLSearchParams(location.search).get("r") || ""
      return r.split("|").find(x => /^so_/i.test(x))
    }

    function getSubmissionOfferFromCache() {
      const rawData = localStorage.getItem(`so_cache.${location.pathname}`)

      if (!rawData) {
        return ""
      }

      try {
        const cached = JSON.parse(rawData)

        const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000
        const now = Date.now()

        if (now - cached.createdAt > thirtyDaysInMs) {
          localStorage.removeItem(`so_cache.${location.pathname}`)
          return ""
        }

        return cached.soPart
      } catch (error) {
        localStorage.removeItem(`so_cache.${location.pathname}`)
        return ""
      }
    }

    return getSubmissionOfferFromQueryString() || getSubmissionOfferFromCache()
  }

  const OFFER_TYPES =
    window.OFFER_TYPES ||
    Object.freeze({
      NEW_CALENDAR: 'new-calendar',
      CARTOON_CALENDAR: 'cartoon-calendar',
      CARTOON_PUZZLE: 'cartoon-puzzle',
      PUZZLE: 'puzzle',
      CANVAS: 'canvas',
      CHRISTMAS_CANVAS: 'christmas-canvas',
      TEXTURED_PAINTING_CANVAS: 'textured-painting-canvas',
      PAINT_EXPLOSION_TUMBLER_FORTY_OZ: '40oz-paint-explosion-tumbler',
      CHRISTMAS_CARD: 'christmas-card',
      BOX_CLUB: 'box-club',
      COLORING_BOOK: 'coloring-book',
      MAGNET: 'magnet',
      THANK_YOU_PAGE: 'thank-you-page',
      OIL_PAINTING_CALENDAR: 'oil-painting-calendar',
      PET_PORTRAIT_BRACELET: 'pet-portrait-bracelet',
      KEEPSAKE_PORTRAIT: 'keepsake-portrait',
      KEEPSAKE_PORTRAIT_VUE: 'keepsake-portrait-vue',
      SUBMISSION_OFFER: 'submission-offer',
    });

  window.OFFER_TYPES = OFFER_TYPES;

  const puzzleOffers = [
    '/personalized-puzzle',
    '/personal-dog-puzzle',
    '/personal-cat-puzzle',
    '/300pc-jigsaw-puzzle',
    // "/cartoon-style-300pc-jigsaw-puzzle"
  ];

  const cartoonCalendarOffers = ['/2026-paw-print-cartoon-calendar'];

  const oilPaintingCalendarOffers = ['/2026-paw-print-oil-painting-calendar'];

  const petPortraitBraceletOffers = ['/products/custom-photo-bracelet-personalized-picture-bangle-keepsake'];

  const keepsakePortraitVueOffers = [
    '/pages/keepsake-portrait-v',
    '/pages/keepsake-portrait-vue',
    '/pages/keepsake-portrait-vue-ct',
    '/pages/keepsake-portrait-vue-free',
    '/pages/keepsake-portrait-s'
  ];

  const keepsakePortraitOffers = ['/pages/keepsake-portrait', '/pages/keepsake-portrait-ct'];

  const cartoonPuzzleOffers = ['/cartoon-style-300pc-jigsaw-puzzle-pm', '/cartoon-puzzle'];

  const canvasOffers = ['/11x-17-wall-canvas'];

  const christmasCanvasOffers = ['/11x-17-christmas-wall-canvas'];

  const texturedPaintingCanvasOffers = ['/11x-17-textured-painting-wall-canvas'];

  const paintingExplosionTumblerOffers = ['/40oz-paint-explosion-tumbler'];

  const christmasCardOffers = ['personalized-christmas-cards', 'christmas-cards'];

  const boxClubOffers = ['/the-paw-print-box-club', '/box-club-2025', '/boxclub-st35'];

  const coloringBookOffers = ['/pet-model-coloring-book', '/pages/coloring-book'];

  const thankYouPageOffers = ['/rp-dog-ty-page', '/rp-cat-ty-page', '/dog-thank-you-page-ig-st-3'];

  const newCalendarOffers = [
    '/n-august-2024-july-2025-paw-print-cat-calendar',
    '/n-august-2024-july-2025-paw-print-dog-calendar',
    '/october-2024-september-2025-paw-print-dog-calendar',
    '/october-2024-september-2025-paw-print-cat-calendar',
    '/2025-paw-print-dog-calendar',
    '/2025-paw-print-dog-calendar-bundle',
    '/2025-paw-print-cat-calendar',
    '/2025-paw-print-cat-calendar-bundle',
    '2025-paw-print-cat-calendar-tw',
    '2025-paw-print-dog-calendar-tw',
    'october-2024-september-2025-paw-print-cat-calendar-tw',
    'october-2024-september-2025-paw-print-dog-calendar-tw',
    '/april-2025-march-2026-paw-print-dog-calendar',
    '/april-2025-march-2026-paw-print-cat-calendar',
    '/june-2025-may-2026-paw-print-cat-calendar',
    '/june-2025-may-2026-paw-print-dog-calendar',
    '/july-2025-june-2026-paw-print-cat-calendar',
    '/july-2025-june-2026-paw-print-dog-calendar',
    '/august-2025-july-2026-paw-print-cat-calendar',
    '/august-2025-july-2026-paw-print-dog-calendar',
    '/september-2025-august-2026-paw-print-cat-calendar',
    '/september-2025-august-2026-paw-print-dog-calendar',
    '/october-2025-september-2026-paw-print-cat-calendar',
    '/october-2025-september-2026-paw-print-dog-calendar',
    '/january-2026-december-2026-paw-print-cat-calendar',
    '/january-2026-december-2026-paw-print-dog-calendar',
    '/january-december-2026-paw-print-cat-calendar',
    '/january-december-2026-paw-print-dog-calendar',
    '/april-2026-march-2027-paw-print-cat-calendar',
    '/april-2026-march-2027-paw-print-dog-calendar',
    '/april-2026-march-2027-paw-print-dog-calendar-ct',
    '/april-2026-march-2027-paw-print-cat-calendar-ct',
    '/july-2026-june-2027-paw-print-dog-calendar',
    '/july-2026-june-2027-paw-print-cat-calendar',
    '/august-2026-july-2027-paw-print-dog-calendar',
    '/august-2026-july-2027-paw-print-cat-calendar',
    '/october-2026-september-2027-paw-print-dog-calendar',
    '/october-2026-september-2027-paw-print-cat-calendar',
    '/january-2027-december-2027-paw-print-cat-calendar',
    '/january-2027-december-2027-paw-print-dog-calendar',
  ];

  window.NEW_CALENDAR_OFFER_URLS = Object.freeze([...newCalendarOffers]);

  const magnetOffers = ['/pages/personalized-holiday-magnet'];

  const offerPriority = [
    { type: OFFER_TYPES.THANK_YOU_PAGE, urls: thankYouPageOffers },
    { type: OFFER_TYPES.NEW_CALENDAR, urls: newCalendarOffers },
    { type: OFFER_TYPES.CARTOON_CALENDAR, urls: cartoonCalendarOffers },
    { type: OFFER_TYPES.CARTOON_PUZZLE, urls: cartoonPuzzleOffers },
    { type: OFFER_TYPES.PUZZLE, urls: puzzleOffers },
    { type: OFFER_TYPES.CANVAS, urls: canvasOffers },
    { type: OFFER_TYPES.CHRISTMAS_CANVAS, urls: christmasCanvasOffers },
    { type: OFFER_TYPES.CHRISTMAS_CARD, urls: christmasCardOffers },
    // { type: OFFER_TYPES.TEXTURED_PAINTING_CANVAS, urls: texturedPaintingCanvasOffers },
    // { type: OFFER_TYPES.PAINT_EXPLOSION_TUMBLER_FORTY_OZ, urls: paintingExplosionTumblerOffers },
    { type: OFFER_TYPES.BOX_CLUB, urls: boxClubOffers },
    { type: OFFER_TYPES.COLORING_BOOK, urls: coloringBookOffers },
    { type: OFFER_TYPES.MAGNET, urls: magnetOffers },
    { type: OFFER_TYPES.OIL_PAINTING_CALENDAR, urls: oilPaintingCalendarOffers },
    { type: OFFER_TYPES.PET_PORTRAIT_BRACELET, urls: petPortraitBraceletOffers },
    { type: OFFER_TYPES.KEEPSAKE_PORTRAIT_VUE, urls: keepsakePortraitVueOffers },
    { type: OFFER_TYPES.KEEPSAKE_PORTRAIT, urls: keepsakePortraitOffers },
  ];

  function determineOfferType() {
    if (window.TPP_TEMPLATE_OFFER_TYPE) {
      window.offerType = window.TPP_TEMPLATE_OFFER_TYPE;
      return window.offerType;
    }

    const soPart = window.getSubmissionOfferForCurrentPage();

    if (soPart) {
      localStorage.setItem(`so_cache.${location.pathname}`, JSON.stringify({
        soPart,
        createdAt: Date.now()
      }));
      window.offerType = OFFER_TYPES.SUBMISSION_OFFER;
      return OFFER_TYPES.SUBMISSION_OFFER
    }

    const currentUrl = window.location.href;

    const matchedOffer = offerPriority.find(({ urls }) => urls.some((offer) => currentUrl.indexOf(offer) > 1));
    const offerType = matchedOffer ? matchedOffer.type : null;

    window.offerType = offerType;

    return offerType;
  }

  window.offerType = null;
  window.determineOfferType = determineOfferType;

  const offerType = determineOfferType();

  console.log('Offer type:', offerType);
})();
